
import React, { useRef, useContext, useEffect } from "react";
import * as THREE from "three";

class Product {
  constructor(currentConfiguration, base, wingLeft, wingMiddle, wingRight, handle) {
    this.currentConfiguration = currentConfiguration;
    this.base = base;
    this.wingLeft = wingLeft ?? { top: null, middle: null, bottom: null };
    this.wingMiddle = wingMiddle ?? { top: null, middle: null, bottom: null };
    this.wingRight = wingRight ?? { top: null, middle: null, bottom: null };
    this.handle = handle;
  }

  setCustom(op) {
    this.currentConfiguration = op;

    this.wingLeft.top.visible = op === "7300a" || op === "7300c";
    this.wingMiddle.top.visible = op === "7300a" || op === "7300c";
    this.wingRight.top.visible = op === "7300a" || op === "7300c";

    this.wingLeft.middle.visible = op === "7300b";
    this.wingMiddle.middle.visible = op === "7300b";
    this.wingRight.middle.visible = op === "7300b";

    this.wingLeft.bottom.visible = op === "7300a" || op === "7300c";
    this.wingMiddle.bottom.visible = op === "7300a" || op === "7300c";
    this.wingRight.bottom.visible = op === "7300a" || op === "7300c";

    this.wingLeft.left.visible = op === "7300c";
    this.wingMiddle.left.visible = false;
    this.wingRight.left.visible = false;

    this.wingLeft.right.visible = false;
    this.wingMiddle.right.visible = false;
    this.wingRight.right.visible = op === "7300c";
  }

  setColor(color) {
    const frame = this.base.children[0].children[0];
    frame.material.color.setHex(color);
  }
}

export default Product;